import { componentCss } from '../../../internal/styles/componentCss';

const transition = {
  transitionProperty: 'transform, background-color, color',
  transitionDuration: '.2s',
  transitionTimingFunction: 'ease',
};

export default componentCss({
  borderRadius: 'button',
  outline: 'none',
  fontSize: 'bodies.small',

  '@media (hover: hover)': {
    ':hover': transition,
  },

  ':active:not(:disabled)': {
    transform: 'scale(0.95)',
    ...transition,
  },
});
